import { api_DELETE, api_GET, api_POST, api_PUT } from "./_api.js";

const diasNaoUteis_api = {
    getList: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`DiasNaoUteis`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    getItem: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`DiasNaoUteis/getItem/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    post: (json) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`DiasNaoUteis`, json)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    put: (json) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`DiasNaoUteis`, json)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    deleteItem: (json) => {
        const promise = new Promise((resolve, reject) => {
            api_DELETE(`DiasNaoUteis/${json.id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    }
}

export default diasNaoUteis_api;
